import {normalizeRotation} from '~/utils/math.js';

export function getImageRotation(rotation) {
  if (rotation === null || rotation === undefined || rotation === '') {
    return null;
  }

  const numericRotation = Number(rotation);
  return Number.isFinite(numericRotation) ? normalizeRotation(numericRotation) : null;
}

export function buildRotatedImageUrl(url, {rotation, ...query} = {}) {
  if (!url) return url;

  const normalizedRotation = getImageRotation(rotation);
  return updateQueryParameters(url, {
    ...query,
    ...(normalizedRotation === null ? {} : {rotate: normalizedRotation})
  });
}

export function getRotatedImageDimensions({width, height, rotation}) {
  const normalizedRotation = getImageRotation(rotation);

  return normalizedRotation !== null && normalizedRotation % 180
    ? {width: height, height: width}
    : {width, height};
}
